import alFlag from "flag-icons/flags/4x3/al.svg";
import atFlag from "flag-icons/flags/4x3/at.svg";
import baFlag from "flag-icons/flags/4x3/ba.svg";
import beFlag from "flag-icons/flags/4x3/be.svg";
import bgFlag from "flag-icons/flags/4x3/bg.svg";
import byFlag from "flag-icons/flags/4x3/by.svg";
import chFlag from "flag-icons/flags/4x3/ch.svg";
import cyFlag from "flag-icons/flags/4x3/cy.svg";
import czFlag from "flag-icons/flags/4x3/cz.svg";
import deFlag from "flag-icons/flags/4x3/de.svg";
import dkFlag from "flag-icons/flags/4x3/dk.svg";
import eeFlag from "flag-icons/flags/4x3/ee.svg";
import esFlag from "flag-icons/flags/4x3/es.svg";
import fiFlag from "flag-icons/flags/4x3/fi.svg";
import frFlag from "flag-icons/flags/4x3/fr.svg";
import gbFlag from "flag-icons/flags/4x3/gb.svg";
import grFlag from "flag-icons/flags/4x3/gr.svg";
import hrFlag from "flag-icons/flags/4x3/hr.svg";
import huFlag from "flag-icons/flags/4x3/hu.svg";
import ieFlag from "flag-icons/flags/4x3/ie.svg";
import itFlag from "flag-icons/flags/4x3/it.svg";
import ltFlag from "flag-icons/flags/4x3/lt.svg";
import lvFlag from "flag-icons/flags/4x3/lv.svg";
import mdFlag from "flag-icons/flags/4x3/md.svg";
import meFlag from "flag-icons/flags/4x3/me.svg";
import mkFlag from "flag-icons/flags/4x3/mk.svg";
import nlFlag from "flag-icons/flags/4x3/nl.svg";
import noFlag from "flag-icons/flags/4x3/no.svg";
import plFlag from "flag-icons/flags/4x3/pl.svg";
import ptFlag from "flag-icons/flags/4x3/pt.svg";
import roFlag from "flag-icons/flags/4x3/ro.svg";
import rsFlag from "flag-icons/flags/4x3/rs.svg";
import ruFlag from "flag-icons/flags/4x3/ru.svg";
import seFlag from "flag-icons/flags/4x3/se.svg";
import siFlag from "flag-icons/flags/4x3/si.svg";
import skFlag from "flag-icons/flags/4x3/sk.svg";
import trFlag from "flag-icons/flags/4x3/tr.svg";
import uaFlag from "flag-icons/flags/4x3/ua.svg";
import xkFlag from "flag-icons/flags/4x3/xk.svg";

import northernCyprusFlag from "./assets/northern-cyprus.svg";

const countryFlagUrls: Readonly<Record<string, string>> = {
  albania: alFlag,
  austria: atFlag,
  belarus: byFlag,
  belgium: beFlag,
  "bosnia-and-herzegovina": baFlag,
  bulgaria: bgFlag,
  croatia: hrFlag,
  cyprus: cyFlag,
  czechia: czFlag,
  denmark: dkFlag,
  estonia: eeFlag,
  finland: fiFlag,
  france: frFlag,
  germany: deFlag,
  greece: grFlag,
  hungary: huFlag,
  ireland: ieFlag,
  italy: itFlag,
  kosovo: xkFlag,
  latvia: lvFlag,
  lithuania: ltFlag,
  moldova: mdFlag,
  montenegro: meFlag,
  netherlands: nlFlag,
  "northern-cyprus": northernCyprusFlag,
  "north-macedonia": mkFlag,
  norway: noFlag,
  poland: plFlag,
  portugal: ptFlag,
  romania: roFlag,
  russia: ruFlag,
  serbia: rsFlag,
  slovakia: skFlag,
  slovenia: siFlag,
  spain: esFlag,
  sweden: seFlag,
  switzerland: chFlag,
  turkey: trFlag,
  ukraine: uaFlag,
  "united-kingdom": gbFlag,
};

interface CountryFlagProps {
  countryId: string;
  name: string;
  color?: string;
  className?: string;
}

export function CountryFlag({ countryId, name, color, className = "" }: CountryFlagProps) {
  const flagUrl = countryFlagUrls[countryId];
  const classes = `country-flag ${className}`.trim();
  if (flagUrl === undefined) {
    return (
      <span
        className={`${classes} country-flag-fallback`}
        style={{ backgroundColor: color }}
        aria-label={`${name} flag`}
        role="img"
      />
    );
  }
  return <img className={classes} src={flagUrl} alt={`${name} flag`} draggable={false} />;
}
